import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import {
  badgeFill,
  eventInk,
  tintCutoff
} from '@features/components/visualization/calendar/utils/calendar-layout.utils';

/**
 * Dumb presentational marker for an event's arrival cutoff, drawn inside the
 * event block. Mirrors the current-time indicator (`calendar-time-step`): the
 * parent computes the placement, here we only render.
 *
 * Three signals for one deadline: a dashed hairline at the instant, the time in
 * a badge beside it, and the region below deepened to read as "orders closed".
 * All three take their hue from the event's own colour rather than a fixed one,
 * so a cutoff always belongs visually to its block even when two blocks sit
 * side by side, and never collides with the red now-line.
 */
@Component({
  selector: 'app-calendar-event-cutoff',
  imports: [DatePipe],
  templateUrl: './calendar-event-cutoff.component.html',
  styles: ``
})
export class CalendarEventCutoffComponent {
  /** Distance in pixels from the top of the event block. */
  offsetPx = input.required<number>();
  /** The deadline itself, rendered in the badge. */
  time = input.required<Date>();
  /** The event's own colour, from which the ink and the zone fill derive. */
  color = input.required<string>();

  protected readonly ink = computed(() => eventInk(this.color()));
  protected readonly zoneFill = computed(() => tintCutoff(this.color()));
  protected readonly timeFill = computed(() => badgeFill(this.color()));
}
